import styled, { css } from 'styled-components'
import { Button, Form, Link } from '@sketch/components'

export const Title = styled.h1<{ bold?: boolean }>`
  margin: 0 0 4px 0;
  font-size: ${({ theme }) => theme.fontSizes.H};
  font-weight: ${({ theme, bold }) =>
    bold ? theme.fontWeights.bold : theme.fontWeights.semibold};
`

export const Section = styled.section<{
  secondary?: boolean
  flexDirection?: string
}>`
  display: flex;
  flex-direction: ${({ flexDirection }) => flexDirection || 'column'};

  margin-bottom: ${({ secondary }) => (secondary ? '48px' : '32px')};

  :last-child {
    margin-bottom: 0;
  }

  ${({ secondary }) =>
    secondary &&
    css`
      ${Title} {
        font-size: ${({ theme }) => theme.fontSizes.G};
      }
    `}

  ${({ flexDirection }) =>
    flexDirection === 'row' &&
    css`
      justify-content: space-between;
      align-items: center;
    `}
`

export const PublishedStatus = styled.span`
  font-weight: 400;
`

export const Description = styled.p`
  max-width: 564px;
  font-size: ${({ theme }) => theme.fontSizes.E};
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
`

export const StyledForm = styled(Form)`
  display: flex;
  align-items: flex-end;
  width: 100%;
`

export const SubmitButton = styled(Button)`
  width: 74px;
  margin-left: 10px; /* stylelint-disable-line scales/space */
  margin-bottom: 5px; /* stylelint-disable-line scales/space */
`

export const InputWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const OtherSettingsContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const Strong = styled.strong`
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
`

export const StyledLink = styled(Link)`
  font-weight: ${({ theme }) => theme.fontWeights.medium};
`
